import React, { Component } from 'react';
import { connect } from 'react-redux';
// import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
// import user from '../../style/images/user.png';

import { Block } from './../../components';

class TrustedContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // test: 'helllo'
    };
  }
  render() {
    return (
      <Col sm={12} md={12}>
        <Block className="tile">
          <Block className="d-flex justify-content-between align-items-center">
            <h3 className="tile-title">Trusted Contact</h3>
            {/* <a className="edit-text">Edit</a> */}
          </Block>
          <Block className="d-block">
            <p>
              This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
              Aenean sollicitudin,
              lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit
              amet nibh vulputate cursus a sit amet mauris.
              <br />
              <br />
              Morbi accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae
              erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue.
              Sed non neque elit. Sed ut imperdiet nisi. Proin condimentum fermentum nunc.
              Etiam pharetra, erat sed fermentum
              feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque.
            </p>
          </Block>
        </Block>
      </Col>


    );
  }
}

export default connect(
  state => ({
    // initialValues: state.companies.resendInviteItem,
    // me: state.auth.user,
    // translations: getTranslations(state),
  }))(TrustedContact);

